import { translateText } from "infra/translation/translate";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import React, { useRef } from "react";
import { useRolesStore } from "presentation/stores/use-roles-list-store";
import ScheduleVacation from "presentation/components/Vacations/ScheduleVacation";
import { VacationSetting } from "presentation/components/Vacations/VacationSetting";
import WebsiteConfigurations from "../WebsiteConfigurations";
import WebsiteBlog from "../WebsiteBlog";
import WebsiteSolutions from "../WebsiteSolutions";
import WebsiteTech from "../WebsiteTech";

const WebsitePanel: React.FC = () => {
  const { roles } = useRolesStore();
  const isAdmin = roles.some((role) => role.name === "Admin");
  const isManager = roles.some(
    (role) => role.name === "Manager" || role.name === "CEO"
  );

  const toast = useRef<Toast>(null);

  return (
    <div>
      <div className="card">
        <TabView>
          <TabPanel
            header={translateText("Configurations", "pt")}
            leftIcon="pi pi-cog mr-2"
          >
            <WebsiteConfigurations />
          </TabPanel>

          <TabPanel
            header={translateText("Blog", "pt")}
            leftIcon="pi pi-tablet mr-2"
          >
            <WebsiteBlog />
          </TabPanel>

          <TabPanel
            header={translateText("Tech", "pt")}
            leftIcon="pi pi-microchip-ai mr-2"
          >
            <WebsiteTech />
          </TabPanel>

          <TabPanel
            header={translateText("Solutions", "pt")}
            leftIcon="pi pi-bullseye mr-2"
          >
            <WebsiteSolutions />
          </TabPanel>
        </TabView>
        <div className="next-bottom"></div>
        <Toast ref={toast} position="bottom-right" />
      </div>
    </div>
  );
};

export default WebsitePanel;
